@import "src/styles/common/_colors.scss";

.legendItemWrapper {
  display: flex;
  padding: 3px 15px;
  gap: 7px;
  align-items: center;
  cursor: pointer;
  outline: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.legendItemWrapper_collapsed {
  padding: 3px 1px;
}

.shapeTimeLine {
  height: 9px;
  width: 9px;
  border: none;
}

.reducedOpacity {
  opacity: 0.4;
}

.labelBlack {
  color: $black;
}
